import React from 'react';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
// import {Editor as ClassicEditor} from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from '@ckeditor/ckeditor5-react'
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react"
import Button from '@mui/material/Button';
import ArrowBackOutlinedIcon from '@mui/icons-material/ArrowBackOutlined';
import axios from "axios";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@mui/material/Tooltip";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ReactHtmlParser, { processNodes, convertNodeToElement, htmlparser2 } from 'react-html-parser';
import "../styles/ckEditor.css";
import { useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import TextField from '@mui/material/TextField';
import ListItem from '@mui/material/ListItem';
import List from '@mui/material/List';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import AddCircleOutlineOutlinedIcon from '@mui/icons-material/AddCircleOutlineOutlined';
import { ToastContainer, toast } from "react-toastify";
import Slide from '@mui/material/Slide';
import CloseIcon from '@mui/icons-material/Close';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import GlobalStyles from "@mui/material/GlobalStyles";
import constants from "../constants.json";
const inputGlobalStyles = (
    <GlobalStyles
        styles={{
            ".ck.ck-balloon-panel": {
                zIndex: "1400 !important", // Put a higher value that your MUI Dialog (generaly 1300)
            },
        }}
    />
);
const FoodFactsDetails = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [openResponsiveDialog, setOpenResponsiveDialog] = useState(false);
    const foodFactsObject = location.state;
    console.log(foodFactsObject)
    const dateNew = new Date();
    let day = dateNew.getDate();
    let month = dateNew.getMonth() + 1;
    let year = dateNew.getFullYear();
    let hour = dateNew.getHours();
    let minutes = dateNew.getMinutes();
    const Transition = React.forwardRef(function Transition(props, ref) {
        return <Slide direction="up" ref={ref} {...props} />;
    });
    // const removePackage = async () => {
    // return { __html: foodFactsObject.foodFactsdata };
    // }
    // const createFoodFacts = async () => {
    //     const createitems = 'https://yqp4a5mgxj.execute-api.eu-north-1.amazonaws.com/develop/foodFacts';
    //     const data = {
    //         title: foodFactsTitleAndDescObject.foodFactstitle,
    //         description: foodFactsTitleAndDescObject.foodFactsDescription,
    //         foodFactsdata: foodFactsData
    //     };
    //     axios
    //         .post(createitems, data)
    //         .then((response) => {
    //             if (response.status) {
    //                 console.log(response);
    //             }
    //         })
    //         .catch((error) => {
    //             console.error(error);
    //         });
    // }
    const ResponsiveDialog = () => {

        const theme = useTheme();
        const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
        const handleClose = () => {
            setOpenResponsiveDialog(false);
            // setReload(!reload);
        };
        const removeFoodFacts = async (id) => {
            const URL = `https://yqp4a5mgxj.execute-api.eu-north-1.amazonaws.com/develop/foodFacts/${id}`;
            await axios
                .delete(URL,
                    {
                        headers: {
                            "authorizationToken": "eyJpdiI6Ik04Rjd1TENYVm5JdlYwcThBVkF6TWc9PSIsCiJ2IjoxLAoiaXRlciI6MTAwMCwKImtzIjoyNTYsCiJ0cyI6NjQsCiJtb2RlIjoiY2NtIiwKImFkYXRhIjoiIiwKImNpcGhlciI6ImFlcyIsCiJzYWx0Ijoib1M1am1kQmJGSnM9IiwKImN0IjoiL0wvZS9vL0dzU0U3UXVvZjdWTTN2eEdWRXp5bSJ9",

                        }
                    })
                .then((response) => {
                    navigate("/foodfacts")
                    alert("Food Fact Has Been Deleted")
                })
                .catch((error) => {
                    // event.preventDefault();
                });
        };

        return (
            <React.Fragment>
                <Dialog
                    fullScreen={fullScreen}
                    open={openResponsiveDialog}
                    onClose={handleClose}
                    aria-labelledby="responsive-dialog-title"
                >
                    <DialogTitle id="responsive-dialog-title">
                        {"Food Facts"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            {constants.areYouYouWantsToDeleteThisFoodFact}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleClose} autoFocus>
                            {constants.close}
                        </Button>
                    </DialogActions>
                    <DialogActions>
                        <Button onClick={() => {
                            removeFoodFacts(foodFactsObject.id)
                            handleClose();
                        }} autoFocus>
                            {constants.accept}
                        </Button>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
    const FullScreenEditDialog = () => {
        const [open, setOpen] = React.useState(false);
        const [description, setDescription] = useState(foodFactsObject.description);
        const [title, setTitle] = useState(foodFactsObject.title);
        const [foodFactsData, setFoodFactsData] = useState(foodFactsObject.foodFactsdata);
        console.log("what", foodFactsObject.foodFactsdata)

        const updateFoodFacts = async (id) => {
            const updateitems = `https://yqp4a5mgxj.execute-api.eu-north-1.amazonaws.com/develop/foodFacts/${id}`;
            const data = {
                title: title,
                description: description,
                foodFactsdata: foodFactsData,
                date: `${day}/${month}/${year}`,
                time: `${hour}:${minutes}`,
            };
            axios
                .put(updateitems, data,
                    {
                        headers: {
                            "authorizationToken": "eyJpdiI6Ik04Rjd1TENYVm5JdlYwcThBVkF6TWc9PSIsCiJ2IjoxLAoiaXRlciI6MTAwMCwKImtzIjoyNTYsCiJ0cyI6NjQsCiJtb2RlIjoiY2NtIiwKImFkYXRhIjoiIiwKImNpcGhlciI6ImFlcyIsCiJzYWx0Ijoib1M1am1kQmJGSnM9IiwKImN0IjoiL0wvZS9vL0dzU0U3UXVvZjdWTTN2eEdWRXp5bSJ9",

                        }
                    })
                .then((response) => {
                    if (response.status) {
                        console.log(response);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        }
        const handleClickOpen = () => {
            setOpen(true);
        };

        const handleClose = () => {
            if (
                document.getElementById("title").value == "" ||
                document.getElementById("description").value == ""
            ) {
                toast(constants.kindlyFillAllFields);
            } else {
                updateFoodFacts(foodFactsObject.id);
                setOpen(false);
                navigate("/foodfacts")
                alert(constants.foodFactHasBeenUpdated)
                // setOpenResponsiveDialog(true);
            }
        };

        return (
            <React.Fragment>
                <div>
                    <ToastContainer />
                </div>
                <div >

                    <Tooltip title={constants.edit}>
                        <IconButton
                            class="ml-2 items-center bg-white-100 hover:bg-green-100  text-sm font-bold rounded-full px-2 py-1" variant="outlined"
                            onClick={handleClickOpen}
                            aria-label={constants.edit}
                        >

                            <ModeEditIcon style={{ color: "black" }} />

                        </IconButton>
                    </Tooltip>
                    <Tooltip title={constants.delete}>
                        <IconButton
                            class="ml-2 items-center bg-white-100 hover:bg-red-200  text-sm font-bold rounded-full px-2 py-1" variant="outlined"
                            onClick={() => {
                                setOpenResponsiveDialog(true);

                            }}
                            aria-label={constants.delete}
                        >
                            <DeleteForeverIcon style={{ color: "red" }} />
                        </IconButton>
                    </Tooltip>
                </div>
                <Dialog
                    fullScreen
                    open={open}
                    onClose={handleClose}
                    TransitionComponent={Transition}
                    disableEnforceFocus
                >
                    <AppBar sx={{ position: 'relative' }}>
                        <Toolbar>
                            <IconButton
                                edge="start"
                                color="inherit"
                                onClick={() => { setOpen(false) }}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {constants.addFoodFacts}
                            </Typography>
                            <Button autoFocus class="ml-2 items-center bg-green-400 hover:bg-red-400  text-lg font-bold rounded px-2 py-1" variant="outlined" onClick={handleClose}>
                                {constants.save}
                            </Button>
                        </Toolbar>
                    </AppBar>
                    <List>
                        <ListItem >
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {constants.title}
                            </Typography>
                        </ListItem>
                        <ListItem >
                            <TextField
                                autoFocus
                                margin="dense"
                                id="title"
                                label={constants.foodFactsTitle}
                                type="text"
                                fullWidth
                                variant="standard"
                                value={title}
                                onChange={(e) => {
                                    setTitle(e.target.value);
                                }}
                            />
                        </ListItem>
                        <ListItem >
                            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                                {constants.shortDescription}
                            </Typography>
                        </ListItem>
                        <ListItem >
                            <TextField
                                multiline
                                autoFocus
                                margin="dense"
                                id="description"
                                label={constants.foodFactShortDescription}
                                type="text"
                                fullWidth
                                variant="standard"
                                value={description}
                                onChange={(e) => {
                                    setDescription(e.target.value);
                                }}
                            />
                        </ListItem>
                        <ListItem >
                            <div style={{ width: "100%" }}>

                                <div style={{ width: "100%" }} className="App">
                                    {open && (
                                        <>
                                            {inputGlobalStyles}
                                            <CKEditor
                                                editor={Editor}
                                                data={foodFactsData}
                                                onReady={editor => {
                                                    // You can store the "editor" and use when it is needed.
                                                    console.log('Editor is ready to use!', editor);
                                                }}
                                                onChange={(event, editor) => {
                                                    const data = editor.getData();
                                                    setFoodFactsData(data)
                                                    console.log({ event, editor, data });
                                                }}
                                                onBlur={(event, editor) => {
                                                    console.log('Blur.', editor);
                                                }}
                                                onFocus={(event, editor) => {
                                                    console.log('Focus.', editor);
                                                }}
                                            />
                                        </>
                                    )
                                    }
                                </div>
                            </div>
                        </ListItem>
                    </List>
                </Dialog>
            </React.Fragment>
        );
    }
    return (
        <div style={{ width: "100%" }}>

            {foodFactsObject && (
                <>
                    <div style={{ margin: "20px", marginBottom: "50px", display: "flex", justifyContent: "space-between" }}>
                        <Button onClick={() => { navigate(-1) }} class="ml-2 items-center bg-green-100 hover:bg-green-400  text-sm font-bold rounded px-2 py-1" variant="outlined" startIcon={<ArrowBackOutlinedIcon />}>
                            Back
                        </Button>
                        <div style={{ display: "flex" }}>
                            <FullScreenEditDialog />
                            <ResponsiveDialog />
                        </div>
                    </div>
                    {/* <Button onClick={()=>{navigate(-1)}} autoFocus>
                            Back
                        </Button> */}
                    <div class="ck-content">

                        {ReactHtmlParser(foodFactsObject.foodFactsdata)}
                    </div>
                </>
            )
            }
        </div>
    )
}

export default FoodFactsDetails;